import { useContextSelectedMotifs } from '../../contexts/selectedMotifContext'
import { useNavigate, useLocation } from 'react-router-dom'
import routePaths from '../../constants/routePaths'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useContextOnboarding } from '../../contexts/onboardingContext'
import { FeatureDiscoveryElement } from '../../types/FeatureDiscoveryElement'
import { cn } from '../../utils/cn'

const MotifCounter = () => {
  const { selectedMotifs } = useContextSelectedMotifs()
  const { featureDiscoveryElementsOpen } = useContextOnboarding()
  const [pulsing, setPulsing] = useState<boolean>(false)
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { t } = useTranslation()

  useEffect(() => {
    setPulsing(true)
  }, [selectedMotifs.length])

  const handleClick = () => {
    navigate(pathname === routePaths.GENERATE ? routePaths.HOME : routePaths.GENERATE)
  }

  return (
    <>
      {selectedMotifs.length === 0 ? null : (
        <div className="fixed bottom-[4vh] left-0 z-20 flex h-[60px] items-center tall-xs:h-[70px] xs:tall-sm:bottom-[18vh] sm:bottom-[9vh] sm:h-[90px] md:h-[100px] lg:h-[120px] xxl:bottom-[15vh] xxl:h-[136px]">
          <div
            style={{ display: 'none' }}
            className={cn(
              'left-0 h-full min-w-[220px] flex items-center absolute bg-black rounded-[0_60px_60px_0] pl-[calc(40px+8px+30px)] pr-[30px] text-[0.875rem] text-white whitespace-pre-wrap select-none [transform:translateX(-50px)] [transition:all_0.4s] opacity-0 [&.show]:[transition-delay:0.6s] [&.show]:[transform:translateX(0)] [&.show]:opacity-100 xs:min-w-[230px] xs:tall-sm:pr-[40px] sm:text-[1.125rem] sm:min-w-[300px] sm:pl-[calc(70px+10px+30px)] md:left-[-15px] md:pl-[calc(80px+10px+30px)] lg:text-[1.5rem] lg:min-w-[370px] xl:pl-[calc(90px+10px+30px)] xxl:min-w-[calc(444px+3vw)] xxl:pr-[44px] xxl:rounded-[0_80px_80px_0] xxl:pl-[calc(122px+3vw+50px)]',
              { show: featureDiscoveryElementsOpen.includes(FeatureDiscoveryElement.HOME) },
            )}
          >
            {t('featureDiscovery.navigateBackHome')}
          </div>
          <button
            className={cn(
              'group relative bottom-[4vh] left-[8px] flex h-[40px] w-[40px] cursor-pointer items-center justify-center rounded-[50%] bg-black95 text-[9px] text-white shadow-floating [border:rgba(0,0,0,0.95)] [transition:color_0.2s] tall-xxs:h-[50px] tall-xxs:w-[50px] max-sm:bottom-[unset] sm:left-[10px] sm:h-[70px] sm:w-[70px] sm:text-[9px] md:h-[80px] md:w-[80px] md:text-[11px] xl:h-[90px] xl:w-[90px] xl:text-[16px] xxl:left-[calc(3vw+6px)] xxl:h-[112px] xxl:w-[112px] [&.pulse]:animate-[pulse_0.2s] [&.red]:bg-red [&.shake:not(.pulse)]:animate-[shake-horizontally-faster_5s_2.5s_ease_infinite]',
              {
                'red shake': pathname !== routePaths.GENERATE,
                pulse: pulsing,
              },
            )}
            onClick={handleClick}
            onAnimationEnd={() => setPulsing(false)}
          >
            <img
              className="max-h-[60%] max-w-[60%] group-[.red]:hidden"
              src={'/icons/home_wt_heart_icon.svg'}
              alt="home-svg"
            />
            <img
              className="hidden max-h-[60%] max-w-[60%] group-[.red]:block"
              src={'/icons/arrow_play_big.svg'}
              alt="arrow-svg"
            />
          </button>
        </div>
      )}
    </>
  )
}

export default MotifCounter
